import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ListenerService } from './listener.service';
import { VariablesService } from './variables.service';
import { Respuesta } from '../interfaces';
import { environment } from '../../../environments/environment';

@Injectable()
export class HttpMethodService {
  
  public baseUrl: string;
  public baseUrlWS: string;
  constructor(private http: HttpClient,
              public listener: ListenerService) {
    // this.baseUrl = 'http://localhost:8000';
    this.baseUrl = environment.baseUrl;
    //this.baseUrl = '';
  }

  get<T>(url: string, data: any = {}): Promise<Respuesta<T>> {
    return this.http.get<Respuesta<T>>(this.baseUrl + url, {headers: this.header(), params: data}).toPromise();
    // .toPromise().then((response) => {
    //   return response;
    // });
  }

  post<T>(url: string, data: any): Promise<Respuesta<T>>  {
    return this.http.post<Respuesta<T>>(this.baseUrl + url, data, {headers: this.header()}).toPromise();
    // .toPromise().then((response) => {
    //   return response;
    // });
  }

  put<T>(url: string, data: any): Promise<Respuesta<T>>  {
    return this.http.put<Respuesta<T>>(this.baseUrl + url, data, {headers: this.header()}).toPromise();
    // .toPromise().then((response) => {
    //   return response;
    // });
  }

  PATCH<T>(url: string, data: any): Promise<Respuesta<T>>  {
    return this.http.patch<Respuesta<T>>(this.baseUrl + url, data, {headers: this.header()}).toPromise();
    // .toPromise().then((response) => {
    //   return response;
    // });
  }

  delete<T>(url: string): Promise<Respuesta<T>> {
    return this.http.delete<Respuesta<T>>(this.baseUrl + url, {headers: this.header()}).toPromise();
  }

  postFormData<T>(url: string, data: FormData): Promise<Respuesta<T>>  {
    return this.http.post<Respuesta<T>>(this.baseUrl + url, data, {headers: this.headerFormData()}).toPromise();
  }

  putFormData<T>(url: string, data: FormData) {
    return this.http.put<Respuesta<T>>(this.baseUrl + url, data, {headers: this.headerFormData()}).toPromise();
  }

  postNoToken<T>(url: string, data: any): Promise<Respuesta<T>>  {
    return this.http.post<Respuesta<T>>(this.baseUrl + url, data, {headers: this.headerFormDataNoToken()}).toPromise();
  }

  postFormDataNoToken<T>(url: string, data: FormData): Promise<Respuesta<T>>  {
    return this.http.post<Respuesta<T>>(this.baseUrl + url, data, {headers: this.headerFormDataNoToken()}).toPromise();
  }

  getNoToken<T>(url: string, data: any = {}): Promise<T>  {
    return this.http.get<T>(this.baseUrl + url, {headers: this.headerFormDataNoToken(), params: data}).toPromise();
  }

  // EXPORTAR<T>(url: string) {
  //   window.open(this.baseUrl + url, '_blank');
  // }

  GETEXTERNAL<T>(url: string, data: any = {}): Promise<Respuesta<T>> {
    return this.http.get<Respuesta<T>>(url, {params: data}).toPromise();
  }
  // ----------------- EXPORTAR -----------------

  exportar<T>(url: string): void {
    window.open(this.baseUrl + url, '_blank');
  }

  async exportarBlob(url: string, data: any = {}) {
    return this.http.get(this.baseUrl + url,
       {headers: this.headerReporte(), 
        responseType: 'blob', 
        params: data
      }).toPromise();
  }

  async exportarBlobNoToken(url: string, data: any = {}) {
    return this.http.get(this.baseUrl + url,
       {headers: this.headerFormDataNoToken(), 
        responseType: 'blob', 
        params: data
      }).toPromise();
  }

  async exportarPdf(url: string, data: any = {}){
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(url,
      {headers: headers, 
       responseType: 'blob', 
       params: data
     }).toPromise();    
  }

  // ----------------- HEADERS -----------------

  private headerReporte() {
    const tokenObj = JSON.parse(localStorage.getItem('tokenCF'));
    if (tokenObj && tokenObj.access_token) {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + tokenObj.access_token);
        return headers;
    }
  }

  private header() {
  
    const tokenObj = JSON.parse(localStorage.getItem('tokenCF'));
    if (tokenObj.access_token) {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + tokenObj.access_token);
        // headers = headers.append('language', 'es');
        headers = headers.append('Content-Type', 'application/json');
        return headers;
    }
  }

  private headerFormData() {
    const tokenObj = JSON.parse(localStorage.getItem('tokenCF'));
    if (tokenObj.access_token) {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', 'Bearer ' + tokenObj.access_token);
        // headers = headers.append('language', 'es');
        return headers;
    }
  }

  private headerFormDataNoToken() {
    let headers = new HttpHeaders();
    // headers = headers.append('language', 'es');
    return headers;
  }

}
